import React, { FunctionComponent } from 'react';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { globalHistory } from '@reach/router';

import { Label, MaterialIcon, P } from '@savebetter/components';

import { PageSectionBlok } from './PageSection';
import { Section } from './Section';

type StoryblokIconOptions = 'Facebook' | 'LinkedIn' | 'Twitter2' | 'Instagram' | 'Youtube' | 'Email';

export interface Blok extends PageSectionBlok {
  footNote?: string;
  sectionTitle?: string;
  links?: Array<StoryblokIconOptions>;
}

interface BlogPostEndingSectionProps {
  blok: Blok;
}

export const BlogPostEndingSection: FunctionComponent<React.PropsWithChildren<BlogPostEndingSectionProps>> = ({
  blok
}) => {
  const { hasBorder, hasBackground, sectionTitle, links = [], footNote, hasPaddingTop, hasPaddingBottom } = blok;
  const currentUrl = globalHistory.location.href;

  const sharingLinks = links.map((option, index) => {
    switch (option) {
      case 'Facebook':
        return (
          <FacebookShareButton key={index} className="mx-2" url={currentUrl}>
            <MaterialIcon name="FacebookOutlinedIcon" color="text-primary" />
          </FacebookShareButton>
        );
      case 'LinkedIn':
        return (
          <LinkedinShareButton key={index} className="mx-2" url={currentUrl}>
            <MaterialIcon name="LinkedInIcon" color="text-primary" />
          </LinkedinShareButton>
        );
      case 'Twitter2':
        return (
          <TwitterShareButton key={index} className="mx-2" url={currentUrl}>
            <MaterialIcon name="TwitterIcon" color="text-primary" />
          </TwitterShareButton>
        );
      case 'Email':
        return (
          <EmailShareButton
            key={index}
            subject={'Thought you might be interested in this Raisin blog post'}
            className="mx-2"
            url={currentUrl}
          >
            <MaterialIcon name="MailOutlineIcon" color="text-primary" />
          </EmailShareButton>
        );
      default:
        return;
    }
  });

  return (
    <Section
      width="md"
      className="flex flex-col justify-center"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <div className="w-max-1/3 flex justify-center flex-col">
        {sectionTitle && (
          <div className="text-center py-6">
            <P>{sectionTitle} </P>
          </div>
        )}
        {links.length > 0 && <div className="text-center flex flex-row justify-center space-x-6">{sharingLinks}</div>}
      </div>

      {footNote && (
        <div className="py-6">
          <Label text={footNote} disabled={true} required={true} />
        </div>
      )}
    </Section>
  );
};
